"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const Request_1 = require("./constants/Request");
const create = params => __awaiter(void 0, void 0, void 0, function* () {
  return yield Request_1.default.post("/v4/activity", params);
});
const get = filters => __awaiter(void 0, void 0, void 0, function* () {
  //Edit data
  let temp = filters;
  if (temp.data) {
    for (const [key, value] of Object.entries(temp.data)) {
      const keyString = "data[" + key + "]";
      temp = Object.assign(Object.assign({}, temp), {
        [keyString]: value
      });
    }
  }
  return yield Request_1.default.get("/v4/activity", Object.assign(Object.assign({}, temp), {
    data: undefined
  }));
});
const getSales = filter => __awaiter(void 0, void 0, void 0, function* () {
  return yield Request_1.default.get("/v4/activity/sales", filter);
});
const remove = activityId => __awaiter(void 0, void 0, void 0, function* () {
  return yield Request_1.default.remove(`/v4/activity/${activityId}`);
});
const set = (activityId, params) => __awaiter(void 0, void 0, void 0, function* () {
  return yield Request_1.default.put(`/v4/activity/${activityId}`, params);
});
exports.default = {
  create,
  get,
  getSales,
  remove,
  set
};